<template>
    <v-card
        min-height="200"
        :class="test"
        :hover="!isSelected"
        @click="clickedFunction"
    >
        <v-card-title>
            <div>
                <div class="headline primary--text">
                    <v-icon color="primary">
                        {{ $appConfig.function.icon }}
                    </v-icon>
                    {{ func.name }}
                </div>
                <v-col cols="12">
                    <div class="grey--text caption">
                        Updated: {{ func.updated_at }}
                    </div>
                </v-col>
                <v-col cols="12">
                    <div class="subheading">
                        {{ func.description }}
                    </div>
                </v-col>

                <template v-if="!func.labels.length">
                    <v-chip label outlined>
                        No label
                    </v-chip>
                </template>
                <template v-else v-for="label in func.labels">
                    <v-chip label outlined>
                        {{ label.name }}
                    </v-chip>
                </template>
            </div>
        </v-card-title>
    </v-card>
</template>
<script>
export default {
    props: {
        func: Object,
        trigger: {},
        isSelected: Boolean
    },
    data() {
        return {
            mytrigger: {}
        };
    },
    computed: {
        test() {
            if (this.isSelected) {
                return "trigger-card-selected";
            } else return "trigger-card-unselected";
        }
    },
    watch: {
        trigger: function() {
            this.mytrigger = this.trigger;
        }
    },
    methods: {
        clickedFunction() {
            this.$emit("selected");
        }
    }
};
</script>
<style lang="css">
.trigger-card-selected {
    background-color: #e8f5e9 !important;
    border: 1px solid #3ba99c;
}
</style>
